export default "__VITE_ASSET__2302c969__"